module.exports = __webpack_public_path__ + "static/media/final-cut-pro.71b6bcce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FreelancerChooser/final-cut-pro.svg
// module id = 2073
// module chunks = 0